// extracted by mini-css-extract-plugin
module.exports = {"main":"PaymentMethodButton_main__3wgDC","mainSelected":"PaymentMethodButton_mainSelected__2b_Ej"};